import { render, staticRenderFns } from "./FormActions.vue?vue&type=template&id=f0cad71a&"
import script from "./FormActions.vue?vue&type=script&lang=js&"
export * from "./FormActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports